var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerDiem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8126",
    "data-name": "Group 8126",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.999,
    viewBox: "0 0 18 17.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    id: "Path_4312",
    "data-name": "Path 4312",
    d: "M1.637,6.545H0V17.181A.818.818,0,0,0,.818,18h9V10.635a.818.818,0,0,1,.818-.818H18V6.545Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    id: "Path_4313",
    "data-name": "Path 4313",
    d: "M15.206,11.455H11.454v6.066l6.066-6.066Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    id: "Path_4314",
    "data-name": "Path 4314",
    d: "M17.181,1.637h-4.64V.818a.818.818,0,0,0-1.637,0v.818H7.091V.818a.818.818,0,1,0-1.637,0v.818H.818A.818.818,0,0,0,0,2.455V4.91H18V2.455a.818.818,0,0,0-.819-.818Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerDiem);
export default __webpack_public_path__ + "static/media/perDiem.0d894413.svg";
export { ForwardRef as ReactComponent };